import { render, staticRenderFns } from "./PlatDataGridSite.vue?vue&type=template&id=ddc68f6a"
import script from "./PlatDataGridSite.vue?vue&type=script&lang=js"
export * from "./PlatDataGridSite.vue?vue&type=script&lang=js"
import style0 from "./PlatDataGridSite.vue?vue&type=style&index=0&id=ddc68f6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports